import {API_URL} from '..'
import {baseRequest} from '../request'
import {REFRESH_REQUEST_TIMEOUT_MS} from './refresh_token_action'
import {recordLogoutReply, setLogoutPending} from './logout_pending'

// The one logout primitive: every caller keeps the signature it has today, `await` it and move on.
//
// the request carries the same 10s timeout as the refresh, so a hung connection ends
// the sign-out instead of stalling it, and any reply that is not the server's definitive answer
// leaves a pending-logout marker behind for the next boot to retry.
export const clearIdentitySession = async (): Promise<void> => {
  try {
    const result = await baseRequest({
      method: 'post',
      url: `${API_URL}/v1/web/identity-logout`,
      timeout: REFRESH_REQUEST_TIMEOUT_MS,
    })
    recordLogoutReply(result?.statusCode)
  } catch {
    // `baseRequest` reports transport failures as `statusCode: null` rather than throwing, but a
    // throw from anywhere else is still a logout the server never confirmed
    setLogoutPending()
  } finally {
    window.sessionStorage.removeItem('labfront')
  }
}
